export const exportGoogleAdsHandler = async (variations) => {
  // Escape helper
  const escapeCsv = (text) => {
    if (text == null) return '';
    const str = String(text);
    if (/["\n,]/.test(str)) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  // Normalize types for PMAX use
  const getNormalizedType = (rawType) => {
    switch (rawType) {
      case 'google_headline':
        return 'headline';
      case 'google_headline_long':
        return 'longHeadline';
      case 'google_description':
        return 'description';
      case 'google_description_short':
        return 'shortDescription';
      default:
        return 'other';
    }
  };

  // Group and sort
  const grouped = {
    headline: [],
    longHeadline: [],
    description: [],
    shortDescription: [],
    other: [],
  };
  variations.forEach((v) => {
    const normType = getNormalizedType(v.assetType);
    grouped[normType].push({ text: v.copyText, score: v.score });
  });

  // Sort each group
  Object.keys(grouped).forEach((key) => {
    grouped[key].sort((a, b) => b.score - a.score);
  });

  // Determine type
  let type;
  if (grouped.longHeadline.length > 0 || grouped.shortDescription.length > 0) {
    type = 'pmax';
  } else {
    type = 'rsa';
  }

  const headers = [];
  const row = [];

  if (type === 'rsa') {
    for (let i = 0; i < grouped.headline.length; i++) {
      headers.push(`Headline ${i + 1}`);
      row.push(escapeCsv(grouped.headline[i]?.text || ''));
    }
    for (let i = 0; i < grouped.description.length; i++) {
      headers.push(`Description ${i + 1}`);
      row.push(escapeCsv(grouped.description[i]?.text || ''));
    }
  } else if (type === 'pmax') {
    const add = (label, items) => {
      items.forEach((item, i) => {
        headers.push(`${label} ${i + 1}`);
        row.push(escapeCsv(item.text));
      });
    };
    add('Headline', grouped.headline);
    add('Long Headline', grouped.longHeadline);
    add('Description', grouped.description);
    add('Short Description', grouped.shortDescription);
  }

  // Finalize CSV
  const csvContent = [headers.join(','), row.join(',')].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `google_ads_export.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
